import React from 'react'
import './navbartop.css'

export default function NavbarTop() {
  return (
    <div className='container-fluid bg-danger'>
   <nav class="navbar ms-5 me-5 navbar-expand-lg bg-danger">
     <div class="container-fluid">
     <a class="navbar-brand" href="/">
      <img className='brand-img' src={require('./Assets/logo.jpeg')} alt="" width="100" height="100"/>
    </a><button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
         <span class="navbar-toggler-icon"></span>
       </button>
       <div class="collapse navbar-collapse" id="navbarSupportedContent">
         <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
           <li class="nav-item">
             <a class="nav-link active" aria-current="page" href="/">Home</a>
           </li>
           <li class="nav-item">
             <a class="nav-link" href="#menu">Menu</a>
           </li>
           <li class="nav-item">
             <a class="nav-link" href="#horario">Horario</a>
           </li>
           <li class="nav-item">
             <a class="nav-link" href="#location">Domicilio</a>
           </li>
         </ul>
       </div>
     </div>
   </nav>
   </div>
  )
}
